module.exports = __webpack_public_path__ + "static/media/tikka_masala_2_placeholder.7bc8a98b.jpg";